import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ETextSize } from '../../common/enums/index.enum';

  
export default /*#__PURE__*/_defineComponent({
  name: 'CustomHeadline',
  props: {
    border: { type: Boolean, default: false },
    clickable: { type: Boolean, default: false },
    noSpacing: { type: Boolean, default: false },
    size: { default: ETextSize.LG },
    text: null,
    uppercase: { type: Boolean, default: false }
  },
  setup(__props: any) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("h1", {
    class: _normalizeClass(["ccn-headline", [
      `ccn-headline--${__props.size}`,
      { 'ccn-headline--border': __props.border},
      { 'ccn-headline--clickable': __props.clickable },
      { 'ccn-headline--no-spacing': __props.noSpacing },
      { 'ccn-headline--uppercase': __props.uppercase },
    ]])
  }, _toDisplayString(__props.text), 3))
}
}

})